import request from "../utils/request"

export function fetchCreatorApplies(params) {
  return request({
    url: "/admin/creator-applies",
    method: "get",
    params
  })
}

export function reviewCreatorApply(id, action, note) {
  return request({
    url: `/admin/creator-applies/${id}/review`,
    method: "post",
    params: { action, note: note || undefined }
  })
}

export function fetchCreators(params) {
  return request({
    url: "/admin/creators",
    method: "get",
    params
  })
}

export function updateCreator(userId, data) {
  return request({
    url: `/admin/creators/${userId}`,
    method: "post",
    data
  })
}

export function removeCreator(userId) {
  return request({
    url: `/admin/creators/${userId}/remove`,
    method: "post"
  })
}

export function fetchCreatorPosts(params) {
  return request({
    url: "/admin/creator-posts",
    method: "get",
    params
  })
}

export function updateCreatorPostStatus(id, auditStatus) {
  return request({
    url: `/admin/creator-posts/${id}/status`,
    method: "post",
    params: { auditStatus }
  })
}

export function deleteCreatorPost(id) {
  return request({
    url: `/admin/creator-posts/${id}/delete`,
    method: "post"
  })
}
